import { render, staticRenderFns } from "./person_change_detail.vue?vue&type=template&id=4b3f8d1a&scoped=true&"
import script from "./person_change_detail.vue?vue&type=script&lang=js&"
export * from "./person_change_detail.vue?vue&type=script&lang=js&"
import style0 from "./person_change_detail.vue?vue&type=style&index=0&id=4b3f8d1a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3f8d1a",
  null
  
)

export default component.exports